<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <v-layout class="justify-space-around mt-2 pb-2 pr-2 pl-0" row>
      <MapContainer>
        <WorldMap_MPMC />
      </MapContainer>

      <v-flex v-show="!$store.state.app.big_map" class="mt-2" lg7 md12 sm12 xl6>
        <top-summary-results class="mb-2" />
        <!--                <dsm-single-text-prod-country class="ma-0 pa-0 " />-->

        <div class="">
          <v-layout row>
            <v-flex class="xs12 sm12 lg12">
              <div class="body-2 font-weight-bold nav nav-tabs">
                <!-- /.tabrow -->
                <li class="">
                  <a class="disabled"
                    >Details ({{ $store.getters.selectionCounts.results.markets_count }}
                    target market x
                    {{ $store.getters.selectionCounts.results.products_count }}
                    products)
                    <help-link help_id="14" style="float: right" />
                  </a>
                </li>
              </div>
            </v-flex>
          </v-layout>

          <div class="tab-content">
            <div class="tab-pane active white">
              <v-container fluid>
                <v-layout class="justify-space-between mt-0 ml-2 mr-1 black--text" row>
                  <v-flex sm12>
                    <applied_filters_box class="mr-3 ml-0 mb-1"></applied_filters_box>
                  </v-flex>
                  <v-flex sm12 class="ml-0">
                    <products_filtered_box></products_filtered_box>
                  </v-flex>
                  <v-flex sm12 class="ml-1 mt-1">
                    <countries_filtered_box></countries_filtered_box>
                  </v-flex>
                  <hr />
                </v-layout>
                <v-layout
                  class="justify-space-between mt-0 ml-2 mr-1 black--text"
                  row
                  v-show="is_run_cube_valid"
                >
                  <v-flex sm12>
                    <reoCubeWrapper></reoCubeWrapper>
                  </v-flex>

                  <v-flex sm12 v-show="false">
                    <v-card
                      v-if="
                        !this.$store.state.tradeDSM.loading_indicator &&
                          $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                            .query_results.cube.length > 0 &&
                          !this.$store.state.app.disable_getters
                      "
                      class="pt-2"
                    >
                      <v-tabs
                        v-model="product_tabs"
                        active-class="trade-blue"
                        background-color="tab_header_color"
                        dark
                        dense
                      >
                        <v-tab> Code (HS6)</v-tab>
                        <!--                        <v-tab> Heading (HS4)</v-tab>-->
                        <!--                        <v-tab> Chapter (HS2)</v-tab>-->
                        <!--                        <v-tab> Section</v-tab>-->

                        <v-tab-item>
                          <v-card flat>
                            <v-layout class="pa-2" row>
                              <v-flex>
                                <reo_table_products
                                  cube="cube_HS6_Code"
                                  table_id="reo_hs6_code"
                                />
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-tab-item>
                        <!--                        <v-tab-item>-->
                        <!--                          <v-card flat>-->
                        <!--                            <v-layout class="pa-2" row>-->
                        <!--                              <v-flex>-->
                        <!--                                <reo_table_products-->
                        <!--                                  cube="cube_HS4_Code"-->
                        <!--                                  table_id="reo_hs4_code"-->
                        <!--                                />-->
                        <!--                              </v-flex>-->
                        <!--                            </v-layout>-->
                        <!--                          </v-card>-->
                        <!--                        </v-tab-item>-->
                        <!--                        <v-tab-item>-->
                        <!--                          <v-layout class="pa-2" row>-->
                        <!--                            <v-flex>-->
                        <!--                              <reo_table_products-->
                        <!--                                cube="cube_HS2_Code"-->
                        <!--                                table_id="reo_hs2_code"-->
                        <!--                              />-->
                        <!--                            </v-flex>-->
                        <!--                          </v-layout>-->
                        <!--                        </v-tab-item>-->
                        <!--                        <v-tab-item>-->
                        <!--                          <v-layout class="pa-2" row>-->
                        <!--                            <v-flex>-->
                        <!--                              <reo_table_products-->
                        <!--                                cube="cube_Section"-->
                        <!--                                table_id="reo_section"-->
                        <!--                              />-->
                        <!--                            </v-flex>-->
                        <!--                          </v-layout>-->
                        <!--                        </v-tab-item>-->
                      </v-tabs>
                      <v-flex class="xs12 sm12 lg12 ml-5 mr-8 mb-9 mt-12"> </v-flex>
                    </v-card>
                    <template v-else>
                      <v-skeleton-loader
                        v-if="$store.state.tradeDSM.loading_indicator"
                        class="mt-3 mb-4"
                        type="article, actions"
                      ></v-skeleton-loader>
                    </template>
                  </v-flex>
                </v-layout>
                <v-layout v-if="!is_run_cube_valid">
                  <v-flex class="xs12 sm12 lg12 ml-5 mr-8 mb-9 mt-12">
                    <reoFrontendTable cube_name="cube_HS6_Code"></reoFrontendTable>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <div
      v-if="
        !$store.state.tradeDSM.loading_indicator &&
          $store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.cube
            .length > 0
      "
    >
      <v-layout
        v-if="
          !$store.state.tradeDSM.loading_indicator &&
            $store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.cube
              .length > 0
        "
        row
      >
        <v-flex v-if="!$store.state.app.big_map" class="xs12 sm12 lg12 ml-5 mr-8 mb-9">
          <DSMMP1CGraphs v-if="is_run_cube_valid"></DSMMP1CGraphs>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import DSMMP1CGraphs from '@/components/trade-dsm-application/result-components/graphs-mp1c';
import TopSummaryResults from '@/components/trade-dsm-application/result-components/top-summary-results';
import WorldMap_MPMC from '@/components/trade-dsm-application/graphs/mpmc/world-map-mpmc';
import countries_filtered_box from '@/components/trade-dsm-application/results-pages/markets-filters-box';
import products_filtered_box from '@/components/trade-dsm-application/results-pages/products-filter-box';
import MapContainer from '@/components/trade-dsm-application/result-components/helpers/map-container';
// import reo_table_products from '@/components/trade-dsm-application/results-pages/tabs/reo_table_products';
import applied_filters_box from '@/components/trade-dsm-application/results-pages/applied-filters-box';
import reoFrontendTable from '@/components/trade-dsm-application/result-components/reo_table/reo-frontend-table';
import reoCubeWrapper from '@/components/trade-dsm-application/result-components/reo_cube_wrapper/reo-cube-wrapper';
import helpLink from '@/components/application-level/help-system/help-link';
import reo_table_products from '@/components/trade-dsm-application/results-pages/tabs/reo_table_products.vue';

export default {
  name: 'tabmp1c',
  components: {
    TopSummaryResults,
    WorldMap_MPMC,
    countries_filtered_box,
    products_filtered_box,
    MapContainer,
    reo_table_products,
    reoFrontendTable,
    applied_filters_box,
    DSMMP1CGraphs,
    reoCubeWrapper,
    helpLink,
  },
  props: {
    cube: {},
    cube_C_Region: {},
    cube_Main_Region: {},
    cube_Trade_Block: {},
    cubehs6code: {},
    cubehs4code: {},
    cubehs2code: {},
    cubesection: {},
    map_rerender_workarount: {},
  },
  data() {
    return {
      tabs: 0,
      product_tabs: 0,
    };
  },
};
</script>
